module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmLeave":"Really discard inputs?"},"de":{"confirmLeave":"Eingaben wirklich verwerfen?"},"fr":{"confirmLeave":"Souhaitez-vous réellement supprimer les entrées ?"}}')
  delete Component.options._Ctor
}
